<script setup>
import { ref, onMounted, computed, watch, inject } from 'vue'
import * as maptalks from 'maptalks';

const props = defineProps({
  options: {},
  width: Number | String,
  height: Number | String
});

const mapRef = ref();

const coordinates = inject('coordinates')
const loading = inject('loading')

const url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

const container = ref();

watch([coordinates, loading], (newVal, oldVal) => {
  if (mapRef.value) {
    marker.setCoordinates(coordinates.value);
    if (oldVal[1]) focusMap(coordinates.value);
  }
}, { deep: true });

const marker = new maptalks.Marker(coordinates.value, { 
  draggable: true, 
  symbol: {
    markerType: 'path',
    markerPath: [
    {
        path: 'M8 23l0 0 0 0 0 0 0 0 0 0c-4,-5 -8,-10 -8,-14 0,-5 4,-9 8,-9l0 0 0 0c4,0 8,4 8,9 0,4 -4,9 -8,14z M3,9 a5,5 0,1,0,0,-0.9Z',
        stroke: '#fff',
      },
      {
        path: 'M 3 9 a 5 5 0 1 0 0 -0.9 Z',
        fill: '#fff',
      }
    ],

    markerPathWidth: 16,
    markerPathHeight: 23,
    markerWidth: 19,
    markerHeight: 29,
  }
});

marker.on('dragend', (param) => {
  coordinates.value = [param.coordinate.x, param.coordinate.y]
});

onMounted(() => {
  if (!container.value) return;

  mapRef.value = Object.freeze({
    map: new maptalks.Map(container.value, props.options),
  });

  mapRef.value.map.on('click', (param) => {
    coordinates.value = [param.coordinate.x, param.coordinate.y];
    marker.setCoordinates(coordinates.value);
  });

  const tileLayer = new maptalks.TileLayer("base", {
    urlTemplate: url,
    subdomains: ["a", "b", "c"],
  });
  mapRef.value.map.addLayer(tileLayer);

  const vectorLayer = new maptalks.VectorLayer("markers");
  mapRef.value.map.addLayer(vectorLayer);


  vectorLayer.addGeometry(marker);
});

const containerStyle = computed(() => ({
  width: props.width ?? '50vw',
  height: props.height ?? '50vh',
}));

function focusMap(coordinates) {
  if (!mapRef.value) {
    return;
  }
  mapRef.value.map.animateTo(
    {
      ...props.options,
      center: coordinates,
    },
    { duration: 200, easing: 'inAndOut' },
  );
}

</script>

<template lang='pug'>
.map-component(
  ref="container" 
  :style="containerStyle"
  )
</template>